import { Observable } from 'rxjs';
import { NewsletterResponse } from '../models/newsletter.model';

export abstract class NewsletterRepository {
    abstract suscribeEmail(email: string): Observable<NewsletterResponse>;
}
